import { restrictCard } from '@mssgme/shared';
import { useWorkspace } from './useWorkspace';

export const useRestrictedCard = () => {
    const workspace = useWorkspace();
    return restrictCard(workspace.card, workspace);
};
